import { Link } from 'react-router-dom';
import { categories } from '@/mocks/asmrData';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-3">
            探索ASMR内容分类
          </h2>
          <p className="text-foreground-600 max-w-xl mx-auto leading-relaxed">
            六大精选分类，覆盖最全面的ASMR体验类型。无论你是新手还是老听众，都能找到心仪的声音。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-2xl p-6 md:p-7 hover:bg-accent-50/30 transition-all duration-300 border border-transparent hover:border-accent-200/60"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-200 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg font-semibold text-foreground-900 mb-2">{cat.name}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{cat.description}</p>
              <span className="inline-flex items-center gap-1 mt-4 text-sm text-accent-600 font-medium group-hover:gap-2 transition-all duration-300">
                浏览内容 <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}